import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { setSubId } from "redux/userInfo";
import { setStepperDisplay } from "redux/stepperReducer";
import { Image } from "lib";
import Label from "lib/Label";
import DynamicForm from "components/DynamicForm";
import verification_badge from "assets/images/validation_checkmark.svg";
import "./index.scss";

const GroupApprovalViewCard = (props) => {
  const {
    title,
    form_field,
    input_fields,
    custom_styles,
    size,
    selectedData,
    group_approval_step_number,
    form_field_items,
  } = props;

  const arrayData = Object.keys(selectedData[form_field]).map((key) => {
    if (key.endsWith(group_approval_step_number)) {
      return selectedData[form_field][key];
    }
  })?.filter((item) => item);
console.log('arrayData', arrayData)

  const id = useSelector((state) => state?.urlEncryption?.urlId);
  const dispatch = useDispatch();
  const subId = useSelector((state) => state.userInfo?.subId);

  useEffect(() => {
    if (!subId && id?.userId) {
      dispatch(setSubId(id?.userId));
      dispatch(setStepperDisplay(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const shouldShowField = (show) => {
    return show ? !!eval(show) : true;
  };

  return (
    <>
      {arrayData?.length > 0 ? (
        arrayData.map((data, index) => (
          <Fragment key={`${index+1}`}>
            <div
              className={`mt-3 p-3 recursive_card ${
                form_field_items?.className || ""
              }`}
            >
              {input_fields?.map((item, idx) => {
                const {
                  label,
                  name,
                  size,
                  show,
                  shouldJoinArray,
                  type,
                  number_verification_required,
                  verification_message,
                } = item;
                const primaryUser = { ...selectedData, ...data };
                delete primaryUser?.source_data;

                return (
                  <Fragment key={`${data?.id}_${name}_${idx}`}>
                    {!type && shouldShowField(show) && (
                      <div className={`${size}`}>
                        <div className="position-relative ps-2">
                          <div className="d-flex justify-content-between">
                            <span>
                              <Label
                                label={label}
                                className="text-muted mb-0"
                              />
                            </span>
                          </div>

                          <div className="d-flex align-items-center">
                            <p
                              className={`mb-0 fw-bold fs-14px break-work-when-exceeds mt-1`}
                            >
                              {shouldJoinArray &&
                              Array.isArray(primaryUser?.[name]) &&
                              primaryUser?.[name]?.length > 0
                                ? primaryUser?.[name]
                                    .map(
                                      (item) =>
                                        item?.label || item?.value || item
                                    )
                                    .join(", ")
                                : primaryUser?.[name]}
                            </p>
                          </div>
                        </div>
                        {number_verification_required && (
                          <div className="verified_badge">
                            <Image
                              className="image_style"
                              imageSrc={verification_badge}
                            />
                            {verification_message}
                          </div>
                        )}
                      </div>
                    )}
                    {type && shouldShowField(show) && (
                      <DynamicForm
                        formFields={item}
                        selectedData={data}
                        primaryUser={primaryUser}
                      />
                    )}
                  </Fragment>
                );
              })}
            </div>
          </Fragment>
        ))
      ) : (
        <div className="d-flex justify-content-center align-items-center">
          <Label label="No Data Found" className="text-muted" />
        </div>
      )}
    </>
  );
};

GroupApprovalViewCard.propTypes = {
  selectedData: PropTypes.object.isRequired,
};

export default GroupApprovalViewCard;
